import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ExpenseForm from '../components/ExpenseForm';
import '../styles/RegisterExpense.css';

const RegisterExpense = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState('');

  const handleExpenseAdded = () => {
    // Mostrar mensaje de éxito
    setSuccessMessage('Gasto registrado exitosamente');
    
    // Limpiar el mensaje después de 3 segundos
    setTimeout(() => {
      setSuccessMessage('');
    }, 3000);
  };

  const handleCancel = () => {
    navigate('/dashboard');
  };

  const handleBackToDashboard = () => {
    navigate('/dashboard');
  };

  return (
    <div className="register-expense-container">
      <header className="register-expense-header">
        <h1>Registro de Gastos</h1>
        <button onClick={handleBackToDashboard} className="back-btn">
          Volver al Dashboard
        </button>
      </header>

      {successMessage && (
        <div className="success-message">
          {successMessage}
        </div>
      )}

      <div className="register-expense-content">
        <ExpenseForm 
          onExpenseAdded={handleExpenseAdded}
          onCancel={handleCancel}
        />
      </div>
    </div>
  );
};

export default RegisterExpense;
